import "./index.scss";
import "./index.print.scss";

import { Box } from "@mui/material";

import StageFollowup01 from "./components/StageFollowup01";
import StageFollowup02 from "./components/StageFollowup02";
import StageFollowup03 from "./components/StageFollowup03";
import StageFollowup04 from "./components/StageFollowup04";
import StageFollowup05 from "./components/StageFollowup05";
import StageInitial from "./components/StageInitial";

const SMS = (props: {
  currentTab: string;
  appointmentNumber: number;
  sendContractToBackend: () => {};
}) => {
  const { currentTab, appointmentNumber, sendContractToBackend } = props;

  if (currentTab !== "sms") return null;
  return (
    <Box className="tcaSms">
      {appointmentNumber === 0 && <StageInitial sendContractToBackend={sendContractToBackend} />}
      {appointmentNumber === 1 && <StageFollowup01 sendContractToBackend={sendContractToBackend} />}
      {appointmentNumber === 2 && <StageFollowup02 sendContractToBackend={sendContractToBackend} />}
      {appointmentNumber === 3 && <StageFollowup03 sendContractToBackend={sendContractToBackend} />}
      {appointmentNumber === 4 && <StageFollowup04 sendContractToBackend={sendContractToBackend} />}
      {appointmentNumber === 5 && <StageFollowup05 sendContractToBackend={sendContractToBackend} />}
    </Box>
  );
};

export default SMS;
